<template>
	<div class="invoice-view">
		<notifications />
		<preloader v-if="isLoading"></preloader>
		<section class="main" id="printable">
			<print-preview :invoice="invoice"></print-preview>
		</section>
	</div>
</template>

<script>
import { relativeUrl, displayDate, isValidDate } from '../../helpers';
import { defaultFields } from "./helpers";
import PrintPreview from './PrintPreview.vue';
import MoreActionButton from "../MoreActionButton";
import printJS from "print-js";
import TimeAgo from "vue2-timeago";
import { RecurringInvoice } from '../../repositories'
import Preloader from "../Preloader.vue"

export default {
	components: { PrintPreview, MoreActionButton, TimeAgo, Preloader },
	data() {
		return {
			invoice: defaultFields(),
			isLoading: false,
			baseUrl: null,
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			const invoiceResponse = await axios.get(`/recurring-invoices/${this.$route.params.id}`);
			// const invoiceResponse = await RecurringInvoice.showAsync();
			this.invoice = this.parseData(invoiceResponse.data.data);
			// window.document.title = this.invoice.number;
		} catch (error) {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
	mounted() {
		this.baseUrl = window.$('meta[name="base-url"]').attr('content');
	},
	methods: {
		relativeUrl, isValidDate,
		parseData(item) {
			return {
				...item,
				payment_terms: JSON.parse(item.payment_terms),
			}
		},
		printProposal() {
			// Pass the element id here
			// this.$htmlToPaper('printable', () => {
			// 	console.log('Printing done or got cancelled!');
			// });

			printJS({
				printable: 'printable', type: 'html', scanStyles: false,
				css: [
					`${this.baseUrl}/css/bootstrap.min.css`,
					`${this.baseUrl}/css/AdminLTE.min.css`,
					`${this.baseUrl}/css/print.css`,
				],
				// documentTitle: this.invoice.number
			});
		},
		async sendEmail() {
			this.isLoading = true;

			try {
				await axios.post(`/recurring-invoices/${this.$route.params.id}/email`);
				this.$notify({
					type: 'success',
					title: 'Sent!',
					text: 'Congratulations, email sent!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		async remove() {
			this.isLoading = true;

			try {
				const response = await axios.delete(`/recurring-invoices/${this.$route.params.id}`);
				window.location.href = relativeUrl(`/recurring-invoices`);
				this.$notify({
					type: 'success',
					title: 'Recurring Invoice Deleted!',
					text: 'You\'ve deleted the proposal!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
	}
}
</script>
